import script from "./LoadingError.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoadingError.vue?vue&type=script&lang=ts&setup=true"

import "./LoadingError.vue?vue&type=style&index=0&id=7d0aa0eb&lang=scss"

const __exports__ = script;

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
